//import axios from "axios";
//window.axios = axios;

window.fbx = require('@fancyapps/ui/dist/fancybox/fancybox.esm').Fancybox;
